import {v35} from './v35';
import sha1 from './sha1';

export const v5 = v35('v5', 0x50, sha1);
